import { useState } from 'react';

import FeedbackButton from '@helsenorge/core-cms/feedbackbutton';
import FeedbackModal from '@helsenorge/core-cms/feedbackmodal';
import type { SurveyDto } from '@helsenorge/framework-utils/additional-page-content';

import styles from './styles.module.scss';

interface FeedbackModalWrapperProps {
  survey: SurveyDto;
  onClose: (id: string) => void;
}

const FeedbackModalWrapper: React.FC<FeedbackModalWrapperProps> = props => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (id: string): void => {
    setIsVisible(false);
    props.onClose(id);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <FeedbackModal
      title={props.survey.title}
      closeButtonText={props.survey.closeButtonText}
      onClose={() => handleClose(props.survey.id)}
      buttons={
        <>
          <FeedbackButton
            onClick={() => {
              window.location.href = props.survey.surveyUrl;
            }}
            variant="outline"
            type="submit"
            value="accept"
          >
            {props.survey.acceptButtonText}
          </FeedbackButton>
          <FeedbackButton variant="borderless" type="submit" value="deny">
            {props.survey.declineButtonText}
          </FeedbackButton>
        </>
      }
    >
      {props.survey.text}

      {props.survey.disclaimerText && (
        <p className={styles.disclaimertext}>{props.survey.disclaimerText.replace('{url}', props.survey.surveyUrl)}</p>
      )}
    </FeedbackModal>
  );
};

export default FeedbackModalWrapper;
